"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AriForm = void 0;
const sdk_1 = require("@ariform/core/sdk");
Object.defineProperty(exports, "AriForm", { enumerable: true, get: function () { return sdk_1.AriForm; } });
const Embed_1 = require("./Embed");
const CDN_1 = __importDefault(require("./CDN"));
const providers_1 = __importDefault(require("./providers"));
sdk_1.AriForm.cdn = new CDN_1.default();
sdk_1.AriForm.Providers = providers_1.default;
sdk_1.AriForm.version = '5.1.0-rc.15';
CDN_1.default.defaultCDN = sdk_1.AriForm.version.includes('rc') ? 'https://cdn.test-ari.form' : 'https://cdn.ari.form';
const isNil = (val) => val === null || val === undefined;
sdk_1.AriForm.prototype.uploadFile = function (storage, file, fileName, dir, progressCallback, url, options, fileKey, groupPermissions, groupId, uploadStartCallback, abortCallback, multipartOptions) {
    const requestArgs = {
        provider: storage,
        method: 'upload',
        file: file,
        fileName: fileName,
        dir: dir
    };
    fileKey = fileKey || 'file';
    const request = sdk_1.AriForm.pluginWait('preRequest', requestArgs)
        .then(() => {
        return sdk_1.AriForm.pluginGet('fileRequest', requestArgs)
            .then((result) => {
            if (storage && isNil(result)) {
                const Provider = providers_1.default.getProvider('storage', storage);
                if (Provider) {
                    const provider = new Provider(this);
                    if (uploadStartCallback) {
                        uploadStartCallback();
                    }
                    return provider.uploadFile(file, fileName, dir, progressCallback, url, options, fileKey, groupPermissions, groupId, abortCallback, multipartOptions);
                }
                else {
                    throw ('Storage provider not found');
                }
            }
            return result || { url: '' };
        });
    });
    return sdk_1.AriForm.pluginAlter('wrapFileRequestPromise', request, requestArgs);
};
sdk_1.AriForm.prototype.downloadFile = function (file, options) {
    const requestArgs = {
        method: 'download',
        file: file
    };
    const request = sdk_1.AriForm.pluginWait('preRequest', requestArgs)
        .then(() => {
        return sdk_1.AriForm.pluginGet('fileRequest', requestArgs)
            .then((result) => {
            if (file.storage && isNil(result)) {
                const Provider = providers_1.default.getProvider('storage', file.storage);
                if (Provider) {
                    const provider = new Provider(this);
                    return provider.downloadFile(file, options);
                }
                else {
                    throw ('Storage provider not found');
                }
            }
            return result || { url: '' };
        });
    });
    return sdk_1.AriForm.pluginAlter('wrapFileRequestPromise', request, requestArgs);
};
sdk_1.AriForm.prototype.deleteFile = function (file, options) {
    const requestArgs = {
        method: 'delete',
        file: file
    };
    const request = sdk_1.AriForm.pluginWait('preRequest', requestArgs)
        .then(() => {
        return sdk_1.AriForm.pluginGet('fileRequest', requestArgs)
            .then((result) => {
            if (file.storage && isNil(result)) {
                const Provider = providers_1.default.getProvider('storage', file.storage);
                if (Provider) {
                    const provider = new Provider(this);
                    return provider.deleteFile(file, options);
                }
                else {
                    throw ('Storage provider not found');
                }
            }
            return result || { url: '' };
        });
    });
    return sdk_1.AriForm.pluginAlter('wrapFileRequestPromise', request, requestArgs);
};
// Esnure we proxy the following methods to the AriFormEmbed class.
['setBaseUrl', 'setApiUrl', 'setAppUrl', 'setProjectUrl', 'setPathType', 'setLicense'].forEach((fn) => {
    const baseFn = sdk_1.AriForm[fn];
    sdk_1.AriForm[fn] = function (arg) {
        const retVal = Embed_1.AriForm[fn](arg, true);
        return baseFn ? baseFn.call(this, arg) : retVal;
    };
});
// For reverse compatability.
sdk_1.AriForm.Promise = Promise;
sdk_1.AriForm.ariformReady = Embed_1.AriForm.ariformReady;
sdk_1.AriForm.config = Embed_1.AriForm.config;
sdk_1.AriForm.builder = Embed_1.AriForm.builder;
sdk_1.AriForm.Report = Embed_1.AriForm.Report;
sdk_1.AriForm.Form = Embed_1.AriForm.Form;
sdk_1.AriForm.FormBuilder = Embed_1.AriForm.FormBuilder;
sdk_1.AriForm.use = Embed_1.AriForm.use;
sdk_1.AriForm.createForm = Embed_1.AriForm.createForm;
sdk_1.AriForm.submitDone = Embed_1.AriForm.submitDone;
sdk_1.AriForm.addLibrary = Embed_1.AriForm.addLibrary;
sdk_1.AriForm.addLoader = Embed_1.AriForm.addLoader;
//Simple
sdk_1.AriForm.encryptUrlKey = '';
sdk_1.AriForm.encryptConfigKey = '';
sdk_1.AriForm.constant = {};
sdk_1.AriForm.serviceId = '';
sdk_1.AriForm.cacheType = '';
sdk_1.AriForm.function = [];
sdk_1.AriForm.callApiFromExternalFunc = () => __awaiter(void 0, void 0, void 0, function* () { return null; });
sdk_1.AriForm.encryptVariable = false; //false;
sdk_1.AriForm.endpointBpmInit = ''; //false;
sdk_1.AriForm.endpointBpmApprove = ''; //false;
sdk_1.AriForm.endpointBpmDoTask = ''; //false;
sdk_1.AriForm.endpointBpmESign = ''; //false;
sdk_1.AriForm.endpointBpmGetData = ''; //false;
sdk_1.AriForm.endpointBpmSendOTP = ''; //false;
sdk_1.AriForm.endpointUploadMediaDoc = '';
sdk_1.AriForm.endpointGetOtp = '';
sdk_1.AriForm.endpointDeleteMediaDoc = '';
sdk_1.AriForm.endpointConvertPdf2Html = '';
sdk_1.AriForm.endpointShowMediaDoc = '';
sdk_1.AriForm.endpointGetCTMInfo = '';
sdk_1.AriForm.inputComponents = [];
sdk_1.AriForm.salt = '';
sdk_1.AriForm.encryptRequest = false;
sdk_1.AriForm.encryptUrl = false;
sdk_1.AriForm.serverPublicKey = '';
sdk_1.AriForm.isBPM = true;
sdk_1.AriForm.tailwindPrefix = 'ari-';
sdk_1.AriForm.uploadFileDirectly = false;
sdk_1.AriForm.additionLink = '';
sdk_1.AriForm.heic2anyUrl = '';
sdk_1.AriForm.loadPermission = true;
sdk_1.AriForm.callApiFromExternal = false;
sdk_1.AriForm.custInfo = {
    gender: ['gender', 'sex'],
    licenseNo: ['licenseno', 'licensenumber'],
    phone: ['phoneno', 'mobile', 'phonenumber', 'phoneNo'],
    dob: ['birthdate', 'dateofbirth', 'birthday', 'dob', "dateOfBirth"],
    fullName: ['fullname', 'name', 'displayname', 'fullName'],
    cif: ['cif', 'customerid', 'customer_id', 'Cif', 'CIF', "custNo"],
    branchCode: ['branchcode', 'branch_id', 'BranchCode']
};
//End Simple
sdk_1.AriForm.addToGlobal = (global) => {
    if (typeof global === 'object' && !global.AriForm) {
        global.AriForm = sdk_1.AriForm;
    }
};
if (typeof global !== 'undefined') {
    sdk_1.AriForm.addToGlobal(global);
}
if (typeof window !== 'undefined') {
    sdk_1.AriForm.addToGlobal(window);
}
Embed_1.AriForm._ariformReady(sdk_1.AriForm);
